import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../store";
import { getSearchParams, fetchGet } from "../../common/common";
import { apiUrl } from "../common/constants";
import HeaderNew from "../header/HeaderNew";
import Footer from "../header/footer";
import SearchTourModify from "./searchTourModify";
import PackageTourList from "./packageTourList";
import { updatePackageData } from "../../actions/search-actions";
// import Modify from "../modify/modify";
// import PackageList from "./PackageList";
import { GetRequest } from "../common/helper";

let srchPrm = "";

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            prevLink: "",
            nextLink: "",
            holdFlag: '',
            packageData:[],
        };
    }

    componentWillMount() {
        srchPrm = getSearchParams();
    }

    componentDidMount(){

        const url = apiUrl.getTourPackageData; 

        this.setState({showLoader:true});

        GetRequest(url).then((response) => {
        //console.log(response);
            if(response){
                const data = JSON.parse(response);
                this.setState({packageData:data})
                this.parsePackageData(data);
            }

            this.setState({showLoader:false});

        }).catch(() => { 
            this.setState({showLoader:false});
        });
    }

    parsePackageData = (data)=>{
        // let srchPrm = this.props.search.searchParams;
        let FromCityId = srchPrm && srchPrm.fromCity.split("|")[0];
        let tourCategory = srchPrm && srchPrm.tourCategory;
        let tourPackage  = srchPrm && srchPrm.tourPackage;
        console.log({FromCityId,tourCategory,tourPackage})

        /* const filterData = data.length > 0 && data.filter((el)=>{
            if(FromCityId == 0 && tourCategory == 0 && tourPackage == 0){
                return el
            }
    
            if((FromCityId == el.FromCityID) && tourCategory == 0 && tourPackage == 0){
               return el;
            }

            if((FromCityId == el.FromCityID) && (tourCategory == 0 && tourPackage == el.PackageId)){
                return el;
             }
    
            if((FromCityId == el.FromCityID) && (tourCategory == el.TourCategoryId) && tourPackage == 0){
              return el;
           }
    
            if((FromCityId == el.FromCityID) && (tourCategory == el.TourCategoryId) && (tourPackage == el.PackageId)){
                return el;
            }
        }) */

        const filterData = data.length > 0 && data.filter(el => {
            if (FromCityId != 0 && FromCityId != el.FromCityID) return false;
            if (tourCategory != 0 && tourCategory != el.TourCategoryId) return false;
            if (tourPackage != 0 && tourPackage != el.PackageId) return false;
            return true;
        });

        store.dispatch(updatePackageData(filterData));
    }

    render() {
        let that = this;
        console.log("that.state.packageData",that.state.packageData);
        return (
            <div>
                <HeaderNew />
                {that.state.showLoader || that.props.search.loader ? (
                    <div className="show-load">
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ) : (
                        <div className="result-container">
                       {that.state.packageData.length >0 && <SearchTourModify data = {that.state.packageData} />}
                        <div className="filter--and--card--wrap">
                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {that.props.search.packageData.length > 0 && <PackageTourList data = {that.props.search.packageData}/>}
                            </div>
                        </div>
                    </div>
                    
                )}
                <Footer />
            </div>
        )
    }
}


const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(Index);